import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import { PopoverProps, Popover, PopoverInteractionKind, Position as BlueprintPosition, } from '@blueprintjs/core';

export interface ITooltipProps extends PopoverProps {
    underline?: boolean;
    children: string | JSX.Element;
}

interface IState {
}

class Tooltip extends React.Component<ITooltipProps, IState> {
    static displayName: string = 'Tooltip';

    render () {
        return (
            <Popover
                {...this.props}
                content={this.props.content}
                enforceFocus={false}
                interactionKind={this.props.interactionKind ? this.props.interactionKind : PopoverInteractionKind.CLICK}
                usePortal={this.props.usePortal !== undefined ? this.props.usePortal : true}
                minimal={this.props.minimal}
                modifiers={this.props.modifiers}
                portalClassName="popover-default-portal"
                popoverClassName={classNames('popover-default-popover popover-tooltip-popover', this.props.popoverClassName)}
                className={classNames(this.props.className, { underlined: this.props.underline })}
                position={this.props.position ? this.props.position : BlueprintPosition.BOTTOM}
            >{this.props.children}</Popover>
        );
    }
}

export default Tooltip;
